export const TRACE_TARGET_REGEX = /^https:\/\/(.*)\/api\/v1\/(.*)/;

export const DEV_PORT = 4200;

export const HEADER_HEIGHT = 40;

export const NAVIGATION_BAR_HEIGHT = 64;

export const SSO_DATA = 'SSO_DATA';

export const LOGO_BASE_URL = 'https://cdn.nft-investment.io/share/logo';
